import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["dropArea", "fileInput"];

    connect() {
        ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            this.dropAreaTarget.addEventListener(eventName, this.preventDefaults.bind(this), false);
            document.body.addEventListener(eventName, this.preventDefaults.bind(this), false);
        });

        ["dragenter", "dragover"].forEach((eventName) => {
            this.dropAreaTarget.addEventListener(eventName, this.highlight.bind(this), false);
        });

        ["dragleave", "drop"].forEach((eventName) => {
            this.dropAreaTarget.addEventListener(eventName, this.unhighlight.bind(this), false);
        });

        this.dropAreaTarget.addEventListener("drop", this.handleDrop.bind(this), false);

        this.fileInputTarget.addEventListener("change", this.handleFileInputChange.bind(this));
    }

    disconnect() {
        ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            this.dropAreaTarget.removeEventListener(eventName, this.preventDefaults.bind(this), false);
            document.body.removeEventListener(eventName, this.preventDefaults.bind(this), false);
        });

        ["dragenter", "dragover"].forEach((eventName) => {
            this.dropAreaTarget.removeEventListener(eventName, this.highlight.bind(this), false);
        });

        ["dragleave", "drop"].forEach((eventName) => {
            this.dropAreaTarget.removeEventListener(eventName, this.unhighlight.bind(this), false);
        });

        this.dropAreaTarget.removeEventListener("drop", this.handleDrop.bind(this), false);
        this.fileInputTarget.removeEventListener("change", this.handleFileInputChange.bind(this));
    }

    preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    highlight() {
        this.dropAreaTarget.classList.add("dragover");
    }

    unhighlight() {
        this.dropAreaTarget.classList.remove("dragover");
    }

    handleDrop(e) {
        const dt = e.dataTransfer;
        const files = dt.files;
        this.fileInputTarget.files = files;
        const event = new Event("change", {bubbles: true});
        this.fileInputTarget.dispatchEvent(event);

        console.log(files);
    }

    handleFileInputChange(event) {
        const files = event.target.files;
        if (files.length > 0) {
            console.log(files)
        }
    }
}